import React, { PropsWithChildren, useEffect, useRef } from 'react';

const OutsideClickDetector = ({
  onOutsideClick,
  children,
}: PropsWithChildren<{ onOutsideClick: () => void }>) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onOutsideClick();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onOutsideClick]);

  return <div ref={ref}>{children}</div>;
};

export default OutsideClickDetector;
